// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------

// Custom Scripts
import { NotLoggedInError } from '../scripts/errorHandling'



// ----------------------------------------------------------------------------
//   Setup
// ----------------------------------------------------------------------------


// Retrieve server URL from env
const SERVER_URL = process.env.REACT_APP_SERVER_URL;

// Enum-style value for user roles
export const userRoles = Object.freeze({
    ADMIN: 'admin',
    STUDENT: 'student',
})



// ----------------------------------------------------------------------------
//   API Fetch Functions
// ----------------------------------------------------------------------------


export const fetchUser = async () => {
    try {
        const resp = await fetch(`${SERVER_URL}/auth/profile`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        });

        // On success, return the user as a JSON object
        if (resp.ok) {
            const user = await resp.json();
            return {username: user.username, role: user.role, use_webcam: user.use_webcam};
        }

        // On 401 (invalid JWT), reflect that the user is not logged in
        else if (resp.status === 401) {
            throw new NotLoggedInError();
        }

        // On any other error, wrap in an error state
        else {
            throw new Error(`Error fetching user: ${resp.status}`);
        }
    } catch (err) {
        throw err;
    }
};


export const fetchStudents = async () => {
    try {
        const resp = await fetch(`${SERVER_URL}/students`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        });
        if (resp.ok) {
            const students = await resp.json();
            return students;
        } else {
            throw new Error(`Error fetching students: ${resp.status}`);
        }
    } catch (err) {
        throw err;
    }
};



// ----------------------------------------------------------------------------
//   Exports
// ----------------------------------------------------------------------------

export default {
    userRoles,
    fetchUser,
    fetchStudents,
};
